module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "无试听权限原因历史",
      "width": "700px",
      "transfer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.logList,
      "loading": _vm.loading,
      "no-data-text": "暂无记录",
      "border": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-915571f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/modal/InvalidListenCauseLogModal.vue
// module id = 1920
// module chunks = 8